import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert } from 'react-bootstrap';

/**
 * Notice banner to inform users that a tab/feature has moved to the Engineering Portal
 * Only displays when the current URL contains "/user"
 * Usage: <EngineeringPortalNoticeBanner />
 */
const EngineeringPortalNoticeBanner = () => {
  const location = useLocation();
  
  // Only show banner if URL contains "/user"
  if (!location.pathname.includes('/user')) {
    return null;
  }
  
  return (
    <Alert variant="warning" className="mx-3 mt-3 mb-3">
      <strong>NOTICE</strong> - This tab has moved to the{' '}
      <Link to="/engineering" className="alert-link">
        Engineering Portal
      </Link>{' '}
      and will be removed soon. Please update your bookmarks and links to point to the new location.
    </Alert>
  );
};

export default EngineeringPortalNoticeBanner;
